<!--This component (step 5) for personnel informations-->
<template>
  <v-card-text>
    <div class="mb-12 headline font-weight-bold headline1--text">
      <span
        v-if="customerInfoMsg && customerInfoMsg[language]"
        v-html="customerInfoMsg[language]"
      ></span>

      <span v-else>
        {{ $t("generic.lang_personnal_info") }}
      </span>
    </div>
    
    <!--Start personnel informations form-->
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container class="px-0">
        <v-row>
          <!--*****************-->

          <v-col cols="12" sm="6" md="6" lg="6" xl="6" v-if="Array.isArray(salutations) && salutations.length > 0">
            <v-select
              v-model="salutation"
              :items="salutations"
              item-value="name"
              item-text="name"
              :rules="[rules.required]"
              :label="$t('generic.lang_salutation')"
              outlined
              required
            ></v-select>
          </v-col>

          <v-col v-if="Array.isArray(salutations) && salutations.length > 0" cols="12" sm="6" md="6" lg="6" xl="6"></v-col>

          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-text-field
              v-model="first_name"
              :rules="[rules.required]"
              @input.native="onInputText"
              @paste.native="onPasteText"
              :label="$t('generic.lang_first_name')"
              outlined
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-text-field
              v-model="last_name"
              :rules="[rules.required]"
              @input.native="onInputText"
              @paste.native="onPasteText"
              :label="$t('generic.lang_last_name')"
              outlined
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-text-field
              v-model="phone"
              :label="$t('generic.lang_phone')"
              outlined
              :rules="[rules.required]"
              type="Number"
              @input.native="onInputUnsafe"
              @paste.native="onPasteUnsafe"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-text-field
              v-model="email"
              :rules="[rules.required, rules.email]"
              type="email"
              :label="$t('generic.lang_email')"
              outlined
              @input.native="onInputUnsafe"
              @paste.native="onPasteUnsafe"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-textarea
              v-model="note"
              @input.native="onInputText"
              @paste.native="onPasteText"
              :label="$t('generic.lang_note')"
              maxlength="10000"
              outlined
              rows="8"
            />
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h4 class="mb-4 font-weight-regular text-md-body-1">
              {{ $t("generic.lang_note_file") }}
            </h4>

            <v-sheet
              width="100%"
              class="justify-center"
              style="cursor: pointer; border: 2px dashed grey;"
              @click="uploadAttachment()"
            >
              <v-container grid-list-xs fill-height align-center justify-center>
                <v-row class="my-2" justify="center">
                  <v-icon color="grey" size="55">
                    mdi-cloud-upload-outline
                  </v-icon>
                </v-row>

                <v-row
                  v-if="this.attachment.name"
                  class="my-2 d-flex align-center"
                  justify="center"
                >
                  <h3 class="grey--text">
                    {{ this.attachment.name }}
                  </h3>

                  <v-btn text icon color="primary" @click="clearAttachment()">
                    <v-icon color="black">mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-sheet>
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-checkbox
              v-model="checkbox"
              :rules="[rules.checkbox]"
              required
              color="blue"
            >
              <template v-slot:label>
                <div @click.stop="">
                  {{ $t("generic.lang_do_you_accept_the") }}

                  <router-link to="/privacy" target="_blank" class="info--text">
                    {{ $t("generic.lang_privacy") }}
                  </router-link>

                  {{ $t("generic.lang_and") }}

                  <router-link
                    to="/conditions"
                    target="_blank"
                    class="info--text"
                  >
                    {{ $t("generic.lang_conditions") }}?
                  </router-link>
                </div>
              </template>
            </v-checkbox>
          </v-col>

          <!--*****************-->
        </v-row>
      </v-container>
    </v-form>
    <!--End personnel informations form-->
  </v-card-text>
</template>

<script>
/*import plugins*/
import { createNamespacedHelpers } from "vuex";
import inputSanitizer from "@/mixins/inputSanitizer";

export default {
  name: "Step5Component",

  mixins: [inputSanitizer],

  data() {
    return {
      valid: true,

      rules: {
        required: (value) => !!value || this.$t('generic.lang_requiredField'),
        first_name: (value) =>
          value.length <= 10 || "First Name must be less than 10 characters",
        last_name: (value) =>
          value.length <= 10 || "Last Name must be less than 10 characters",
        phone: (value) =>
          value.length <= 10 || "Phone must be less than 10 characters",
        //(value) => !isNaN(value),
        email: (value) => !value || this.isEmail(value) || this.$t('generic.lang_emailMustBeValid'),
        checkbox: (value) => !!value || this.$t('generic.lang_youMustAgreeToContinue'),
      },
    };
  },

  computed: {
    ...createNamespacedHelpers("customerData").mapState(["attachment"]),
    ...createNamespacedHelpers("config").mapGetters(["customerInfoMsg"]),

    language() {
      return this.$i18n.locale;
    },
    salutations() {
      return this.$store.state.config.salutations;
    },
    salutation: {
      get() {
        return this.$store.state.customerData.salutation;
      },
      set(val) {
        this.$store.commit("customerData/addSalutation", val);
      },
    },
    first_name: {
      get() {
        return this.$store.state.customerData.first_name;
      },
      set(val) {
        this.$store.commit("customerData/addFirstName", this.cleanText(val));
      },
    },
    last_name: {
      get() {
        return this.$store.state.customerData.last_name;
      },
      set(val) {
        this.$store.commit("customerData/addLastName", this.cleanText(val));
      },
    },
    phone: {
      get() {
        return this.$store.state.customerData.phone;
      },
      set(val) {
        this.$store.commit("customerData/addPhone", this.cleanUnsafe(val));
      },
    },
    email: {
      get() {
        return this.$store.state.customerData.email;
      },
      set(val) {
        this.$store.commit("customerData/addEmail", this.cleanUnsafe(val).trim());
      },
    },
    note: {
      get() {
        return this.$store.state.customerData.note;
      },
      set(val) {
        this.$store.commit("customerData/addNote", this.cleanText(val));
      },
    },
    checkbox: {
      get() {
        return this.$store.state.customerData.checkbox;
      },
      set(val) {
        this.$store.commit("customerData/addCheckbox", val);
      },
    },
  },

  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async uploadAttachment() {
      // store a reference to our file handle
      let fileHandle;

      // open file picker
      await window
        .showOpenFilePicker({
          types: [
            {
              description: "Custom Files",
              accept: {
                "image/png": [".png"], //Extensions you want to allow
                "image/jpeg": [".jpeg"],
                "image/jpg": [".jpg"],
                "image/svg": [".svg"],
                "image/webp": [".webp"],
                "text/plain": [".pdf", ".doc", ".docx", ".xsl", ".txt"],
              },
            },
          ],
          excludeAcceptAllOption: true, // this hides all files option
          multiple: false,
        })
        .then(async (data) => {
          [fileHandle] = data;

          // get file contents
          const fileData = await fileHandle.getFile();
          //const content = await fileData.text();

          this.toBase64(fileData)
            .then((result) => {
              let res = result.slice(result.indexOf(",") + 1);
              this.$store.commit("customerData/addAttachment", {
                name: fileData.name,
                value: res,
              });
            })
            .catch((err) => {
              this.$swal({
                title: this.$t("generic.lang_error"),
                icon: "error",
                text: err.message,
              });
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    clearAttachment() {
      this.$store.commit("customerData/addAttachment", { name: "", value: "" });
    },
  },
};
</script>
